export default {
  dba_ds_report: 'Data Science Report',
  dba_agent_token_total_done: 'Completed. Total tokens consumed {tokens}.',
  dba_agent_thinking: '{agentName} is processing data...',
  dba_agent_thinking_ds:
    'Ready in 5 mins. Conversation saved. You can leave anytime.',
  dba_agent_time_spent: 'Time: ',
  dba_agent_thinkover_fastqa: '{agentName} quick thinking and query completed',
  dba_agent_thinkover_deepthink:
    '{agentName} deep thinking and query completed',
  dba_agent_thinkover_auto: '{agentName} auto thinking and query completed',
  dba_agent_thinkover_default: '{agentName} thinking and query completed',
  dba_agent_plan_done: '{agentName} plan execution completed',
  dba_source_tip_all:
    'Intelligence & Opinions available, Dashboard partially supported, PUBGM excluded',
  dba_source_tip: 'Intelligence, Opinions and Dashboard available.',
  dba_source_tip_no_dashboard: 'Dashboard partially supported, PUBGM excluded',
  dba_may_also_ask: 'Suggested Questions',
  dba_time_over: 'Data query timed out. Please try again later.',
  dba_qa_ask: 'Ask anything about game data',
  dba_qa_ask_skill:
    'Type your question, type @ for Knowledge Base, or / for Skills...',
  dba_qa_ask_knowledge: 'Type your question, or type @ for Knowledge Base',
  dba_qa_ask_skill_only: 'Type your question, or type / for Skills...',
  dba_qa_ask_question: 'Type your question',
  dba_qa_ai_table_ask:
    'Please Enter A Question About The Game. Get table results.',
  dba_qa_techland_ask:
    'Ask about Techland game data. Polish queries are supported',
  dba_title_left: 'Your',
  dba_title_right: 'Game Data Agent',
  dba_change_list: 'Refresh',
  dba_input_send: 'Send',
  dba_input_voice: 'Voice input',
  dba_input_stop: 'Stop',
  dba_new_qa: 'New Chat',
  dba_menu_today: 'Today',
  dba_menu_week: 'Past 7 Days',
  dba_menu_month: 'Past 30 Days',
  dba_menu_early: 'Earlier',
  dba_menu_share: 'Share',
  dba_menu_share_link: 'Share Link',
  dba_menu_share_caption:
    'This shared content is accessible only to users with report viewing permissions.',
  dba_menu_sensitive_content_mgmt:
    'Your current session contains Mgmt true game data and cannot be shared at the moment.',
  dba_menu_sensitive_content_both:
    'Your current session contains Mgmt and Dashboard true game data and cannot be shared at the moment.',
  dba_menu_sensitive_content:
    'Your current session contains Dashboard true game data and cannot be shared at the moment.',
  dba_menu_sensitive_data_detected: 'Sensitive Data Detected',
  dba_menu_rename: 'Rename',
  dba_menu_confirm: 'Confirm Deletion?',
  dba_menu_confirm_content:
    'The chat history will be permanently deleted and cannot be recovered.',
  dba_menu_chat_archive: 'Favourite',
  dba_menu_chat_archive_done: 'Added to Favourites',
  dba_menu_chat_archive_remove: 'Remove Favourite',
  dba_menu_chat_archive_remove_done: 'Removed Favourite',
  dba_qa_save:
    'A maximum of 50 conversations can be saved, with the longest storage time being 0.5 years.',
  dba_home_hello: 'Hi, I am ',
  dba_home_brainy: 'Brainy',
  dba_regenerate: 'Regenerate',
  dba_data_sources: 'Data Sources',
  dba_data_insight: 'Data Insight',
  dba_switch_agent: 'Switch to agent: ',
  dba_go_to_agent: 'Go to agent',
  dba_switch_tool: 'Use tool: ',
  dba_tools_running: '{count} {tool} tools running',
  dba_tools_completed: '{count} {tool} tools',
  dba_chart_stop: 'Generation has been stopped.',
  dba_switch_voice_to_text_failed: 'Voice recognition failed',
  dba_input_cancel: 'Cancel',
  dba_common_like: 'Like',
  dba_common_unlike: 'Dislike',
  dba_common_edit: 'Edit',
  dba_common_copy: 'Copy',
  dba_common_refresh: 'Regenerate',
  dba_common_copy_success: 'Copy succeeded',
  dba_common_copy_failed: 'Copy failed, please try again',
  dba_common_edit_failed: 'Edit Failed',
  dba_common_feedback_tips: 'Thank you for your feedback!',
  dba_common_refresh_failed: 'Regenerate Failed',
  dba_ParseError:
    'Network request parsing failed. Please check your connection or try again later.',
  dba_invalid_request: 'Invalid request. Please refresh the page or try again.',
  dba_method_notFound:
    'The requested service does not exist. Please verify your operation.',
  dba_invalid_params:
    'Parameter validation failed. Please check your input and try again.',
  dba_internal_error:
    'Too many users are currently accessing the system. Please try again later.',
  dba_internal_length_max:
    'Submission exceeds character limit. Please shorten your input and try again.',
  dba_max_turns:
    "The AI model has reached its processing limit. We've been notified. Please try again.",
  dba_menu_loading: 'Loading…',
  dba_deep_thinking: 'Deep Thinking',
  dba_deep_on: 'ON: Gives detailed, in-depth answers (slower response)',
  dba_deep_off: 'OFF: Gives quick, basic answers (faster response)',
  dba_upload_img_title: 'Upload Attachment',
  dba_upload_img_tips: `Up to 5 files.<br/>Supported formats:​ Markdown (.md), PDF (.pdf), Word (.docx), PPT (.pptx), Excel (.xlsx), Html (.html), Image (.jpg, .png).<br/> Size limits: Images(5 MB each), Markdown(1 MB each), Other files: 10 MB each.`,
  dba_upload_img_tips_darg: `Up to 5 files.Supported formats:​ Markdown (.md), PDF (.pdf), Word (.docx), PPT (.pptx), Excel (.xlsx), Html (.html), Image (.jpg, .png).<br/> Size limits: Images(5 MB each), Markdown(1 MB each), Other files: 10 MB each.`,
  dba_upload_img_error_tips:
    'Up to 5 files. Supported formats: Markdown, PDF, Word, PPT, Excel, Html, PNG, JPG.<br/>Images ≤5 MB, Markdown ≤1 MB, others ≤10 MB.',
  dba_upload_img_disabled_tips:
    '{agentName} Agent does not support uploading images and files',
  dba_upload_img_disabled_send_tips:
    'Please delete the invalid files before sending.',
  dba_upload_error: 'Upload Error',
  dba_uploading: 'Uploading...',
  dba_reupload: 'Click to retry',
  dba_upload_drag_title: 'Drag & drop files here, or click to upload',
  dba_access_nodash:
    'All insights are based on third-party data from the Intelligence subsystem and may contain inaccuracies. Please refer to them carefully.',
  dba_access_dash2_left: 'You do not have access to ',
  dba_access_dash2_right:
    ' Dashboard true game data; All insights are based on third-party data from the Intelligence subsystem and may contain inaccuracies. Please refer to them carefully.',
  dba_access_dash3_left: 'You have ',
  dba_access_dash3_mid: ' Dashboard true game data, but not ',
  dba_access_dash3_right: '. Insights include real ',
  dba_access_dash3_end: ' Dashboard data. Please share carefully.',
  dba_access_dash4_mid: ' Dashboard true game access. Insights include real ',
  dba_access_title: 'Sensitive Data Notice',
  dba_user_cost_exceeded_tip:
    'This task is complete. DataBrain premium model usage has reached its limit. Continuing will automatically switch to the basic model service.',
  // 管理看板相关文案
  dba_access_mgmt_intelligence:
    'You have Mgmt dashboard access. Insights include real Mgmt Dashboard data. Please share carefully.',
  dba_access_mgmt_dashboard: 'Mgmt',
  dba_access_mgmt_permission_and: ' and ',
  dba_access_mgmt_dashboard_and: ' and ',
  dba_access_mgmt_permission_comma: ', ',
  dba_access_mgmt_intelligence_prefix: 'You have ',
  dba_access_mgmt_intelligence_suffix:
    ' dashboard access. Insights include real ',
  dba_access_mgmt_intelligence_end: ' Dashboard data. Please share carefully.',
  dba_access_table: 'Data Source Explanation',
  dba_access_table_hover: 'The data source is from',
  dba_access_table_Intelligence: 'Intelligence, third-party data sources',
  dba_access_table_Opinions: 'Opinions, web scraping data',
  dba_access_table_Dashboard: 'Dashboard, real game data',
  dba_access_table_Intelligence_new:
    'Intelligence,  DataBrain estimates based on third-party data sources',
  dba_voice_listen: 'Listening...',
  dba_voice_reco: 'Recognizing...',
  dba_voice_fail: 'Could not understand, please say it again.',
  dba_invalid_agent:
    'A connection to the AI service was interrupted. Please refresh or try again.',
  dba_invalid_image:
    'The image could not be processed. Please try a different file.',
  dba_over_token:
    'Sorry, the answer exceeds the limit. Agent is being optimized. Please simplify your question if urgent.',
  dba_rate_limit:
    'Too many users are currently accessing the system. Please try again later.',
  dba_chat_share_user: 'Chat Transcript from xxx',
  dba_chat_systeem_error: 'System Error',
  dba_chat_new_menu: 'New Chat',
  dba_chat_feedback_title: 'What we can improve?',
  dba_chat_feedback_placeholder:
    'Please tell us what was wrong, or what you were expecting.',
  dba_common_share_failed: 'Share Error',
  dba_request_limit: 'Network error, please wait a moment and try again.',
  dba_execution_timeout:
    'Agent execution exceeded the 30-minute time limit. Please retry with a narrower query.',
  dba_invalid_input: 'Invalid input. Please check your input and try again.',
  dba_download: 'Download',
  dba_downloading: 'Downloading...',
  dba_download_success: 'Downloaded.',
  common_down_loading_text: 'Downloading',
  common_down_loading_text_loading: 'Downloading...',
  common_down_success_text: 'Download Successfully',
  common_down_error_text: 'Download Failed',
  dba_copilot_recommend: 'Recommended Questions',
  /** Copilot 侧栏首页推荐区标题（轻量化文案，仅 Copilot 使用） */
  dba_copilot_sidebar_recommend_title: 'Recommended',
  dba_search_chats: 'Search',
  dba_archive_title: 'Favourite',
  dba_file_library_title: 'Library',
  dba_file_library_tab_all: 'All',
  dba_file_library_tab_brainy: 'Brainy Generated',
  dba_file_library_tab_user: 'My Uploads',
  dba_file_library_search_placeholder:
    'Search file name, source',
  dba_file_library_col_name: 'File Name',
  dba_file_library_col_source: 'Source',
  dba_file_library_col_created: 'Created At',
  dba_file_library_col_size: 'Size',
  dba_file_library_col_type: 'Type',
  dba_file_library_col_actions: 'Actions',
  dba_file_library_open_chat: 'Original Chat',
  dba_file_library_download: 'Download',
  dba_file_library_filter: 'Filter',
  dba_file_library_filter_title: 'Filter Criteria',
  dba_file_library_filter_clear: 'Clear',
  dba_file_library_filter_file_type: 'File Type',
  dba_file_library_filter_time: 'Time Range',
  dba_file_library_filter_source: 'Source',
  dba_file_library_filter_all: 'All',
  dba_file_library_time_today: 'Today',
  dba_file_library_time_7d: 'Last 7 days',
  dba_file_library_time_30d: 'Last 30 days',
  dba_file_library_source_search: 'Search',
  dba_file_library_source_agent: 'Agent',
  dba_file_library_source_skill: 'Skill',
  dba_file_library_source_placeholder: 'Select source',
  dba_file_library_please_select: 'Please select',
  dba_file_library_empty: 'No files',
  dba_file_library_loading: 'Loading...',
  dba_file_library_prev: 'Previous',
  dba_file_library_next: 'Next',
  dba_file_library_type_pdf: 'PDF',
  dba_file_library_type_ppt: 'PPT',
  dba_file_library_type_word: 'Word',
  dba_file_library_type_excel: 'Excel',
  dba_file_library_type_csv: 'CSV',
  dba_file_library_type_html: 'HTML',
  dba_file_library_type_md: 'Markdown',
  dba_file_library_type_txt: 'TXT',
  dba_file_library_type_zip: 'ZIP',
  dba_file_library_type_image: 'Image',
  dba_common_flat_bar_chart: 'Grouped Bar Chart',
  dba_later_viewing_text: 'Conversation saved. You can leave anytime.',
  dba_no_search_result: 'No Results Found',
  dba_new_agent: 'Go to Agent',
  dba_common_custom_q: 'Confirm the plan and generate the report',
  dba_magic_poster_confirm_generate: 'Confirm the plan and generate the poster',
  dba_magic_poster_regenerate: 'Regenerate the data magic poster',
  dba_magic_poster_high_quality:
    '3 high-quality generations per day. Standard mode after.',
  dba_chat_type_ai_agent: 'Smart QA',
  dba_chat_type_ds_agent: 'Data Science Report',
  dba_chat_type_magic_poster: 'AI Magic Poster',
  dba_magic_poster_placeholder: 'Please Enter A Question About The Game',
  dba_magic_poster_inspiration_title: 'Poster Inspiration',
  dba_magic_poster_make_same: 'Make Same',
  dba_magic_poster_preview: 'View Details',
  dba_magic_poster_preview_close: 'Close',
  dba_magic_poster_custom_style: 'Custom Style',
  dba_magic_poster_default_style: 'Key Metrics Overview',
  dba_magic_poster_quota_remaining: '{count} remaining today',
  dba_magic_poster_quota_exhausted:
    'Daily limit reached. Please try again tomorrow.',
  dba_magic_poster_generating: 'Generating poster...',
  dba_magic_poster_generate_btn: 'Generate Magic Poster',
  dba_magic_poster_export_png: 'Export PNG',
  dba_magic_poster_share: 'Share',
  dba_magic_poster_switch_style: 'Switch Style',
  dba_magic_poster_custom_input_placeholder:
    'Enter your custom style description',
  dba_chat_type_ai_table: 'AI Sheet',
  dba_ds_agent_section_title: 'Expert Agent',
  dba_no_permission: 'No\nAuths',
  dba_no_permission_desc: 'Please apply for permissions: ',
  dba_ds_qa_ask: 'Please enter parameters: time, region, channel, etc',
  dba_ds_model_sample_empty_choice:
    'Please select a report template and try again',
  dba_ds_report_export: 'Export',
  dba_ds_report_export_error: 'Export Error',
  dba_ds_report_export_content:
    'The exported file contains real operational data of the game. Please be cautious when sharing it.',
  dba_ds_report_reset: 'Reset Content',
  dba_ds_report_reset_content:
    'This action will restore the file to its original version. The operation cannot be undone. Do you want to continue?',
  dba_ds_report_reset_success: 'Successfully reset to the original version.',
  dba_confirm: 'Confirm',
  dba_cancel: 'Cancel',
  dba_close: 'Close',
  dba_loading: 'Loading...',
  /** AI Gallery HTML preview panel */
  /** Preview tab: placeholder when no content */
  dba_ai_gallery_preview_placeholder: 'No preview content',
  /** Preview loading error */
  dba_ai_gallery_preview_error: 'Preview loading failed',
  /** HTML artifact card subtitle (same line as "HTML · …") */
  dba_ai_gallery_panel_title: 'AI Gallery Preview',
  dba_ai_gallery_document_hint: 'Preview or view code',
  /** ZIP file card subtitle */
  dba_zip_file_download_hint: 'Click to download file',
  /** Hover tip when document card is disabled in Copilot mode */
  dba_document_copilot_disabled: 'Preview not available in Copilot mode',
  /** Toolbar: label next to copy icon */
  dba_ai_gallery_toolbar_copy_label: 'Copy',
  /** Toolbar: label next to export icon */
  dba_ai_gallery_toolbar_export_label: 'Export',
  /** Export button tooltip */
  dba_ai_gallery_export_html_tooltip: 'Export HTML file',
  /** Toolbar: label next to fullscreen icon */
  dba_ai_gallery_toolbar_fullscreen_label: 'Fullscreen',
  /** Fullscreen button tooltip */
  dba_ai_gallery_fullscreen_tooltip: 'Open in new page',
  /** Primary publish action (AI Gallery toolbar) */
  dba_ai_gallery_publish: 'Publish',
  dba_kb_mention_trigger: 'Knowledge Base',
  dba_kb_mention_empty: 'No matching knowledge base',
  dba_kb_doc_count_unit: 'docs',
  dba_kb_time_recent_week: 'Past week',
  dba_kb_select_title: 'Select Knowledge Base',
  dba_kb_first_level_title: 'Knowledge Base',
  dba_kb_second_level_title: 'Documents',
  dba_kb_search_placeholder: 'Search files or knowledge bases',
  dba_kb_doc_empty: 'No documents',
  dba_kb_citation_title: 'Knowledge Base References',
  dba_kb_citation_expand: 'Expand for more files',
  dba_kb_citation_view_source: 'View Source',
  dba_kb_citation_collapse: 'Collapse',
  dba_kb_citation_expand_fragment: 'Expand Fragment',
  dba_kb_citation_docs_unit: ' docs',
  /** Inline collapsed mention: @KB Ndocs */
  dba_kb_inline_doc_unit: 'docs',
  dba_kb_citation_chunk_count: '{count} chunks',
  dba_kb_citation_subtitle: 'Based on {names} · Source file retrieval',
  dba_kb_add_modal_caption: 'Add to Knowledge Base',
  dba_kb_add_tab_existing: 'Add to Existing',
  dba_kb_add_tab_new: 'Create New',
  dba_kb_add_space_personal: 'Personal Space',
  dba_kb_add_space_team: 'Team Space',
  dba_kb_add_select_kb: 'Please select a knowledge base',
  dba_kb_add_title: 'Title',
  dba_kb_add_title_placeholder: 'Enter title',
  dba_kb_add_content: 'Content',
  dba_kb_add_content_placeholder: 'Enter content',
  dba_kb_add_kb_name: 'Knowledge Base',
  dba_kb_add_kb_desc: 'Description',
  dba_kb_add_confirm: 'Confirm',
  dba_kb_add_confirm_go: 'Confirm & View',
  dba_kb_add_selection_btn: 'Add to Knowledge Base',
  dba_kb_add_failed: 'Failed to add to knowledge base. Please try again.',
  dba_kb_add_success: 'Successfully saved to {kbName}',
  dba_kb_add_space: 'Space',
  dba_kb_add_space_team_disabled_tooltip: 'No team space available. ',
  dba_kb_add_space_team_disabled_link: 'Click to create one',
  dba_kb_add_space_team_disabled_suffix: ' in the Knowledge Base.',
  dba_kb_add_select_team: 'Team Space',
  dba_kb_add_target_kb: 'Target Base',
  dba_kb_add_ai_toggle: 'AI Organize',
  dba_kb_add_title_required: 'Title is required',
  dba_kb_add_content_required: 'Content is required',
  dba_kb_add_kb_required: 'Please select a knowledge base',
  dba_kb_add_kb_name_required: 'Knowledge base name is required',
  dba_kb_add_team_required: 'Please select a team',
  dba_kb_add_kb_name_placeholder: 'Enter knowledge base name',
  dba_kb_add_kb_desc_placeholder: 'Enter description (optional)',
  /** Modal caption — Publish as webpage */
  dba_ai_gallery_publish_modal_caption: 'Publish as webpage',
  // Form field labels
  dba_ai_gallery_publish_name_cn: 'Chinese Title',
  dba_ai_gallery_publish_name_cn_placeholder: 'Enter Chinese title',
  dba_ai_gallery_publish_name_en: 'English Title',
  dba_ai_gallery_publish_name_en_placeholder:
    'e.g. Honor of Kings Season Review',
  dba_ai_gallery_publish_desc_cn: 'Chinese Description',
  dba_ai_gallery_publish_desc_cn_placeholder:
    'Briefly describe content, highlights and scenarios...',
  dba_ai_gallery_publish_desc_en: 'English Description',
  dba_ai_gallery_publish_desc_en_placeholder:
    'Briefly describe your work, highlights and use cases...',
  dba_ai_gallery_publish_tags: 'Tags',
  dba_ai_gallery_publish_tags_placeholder: 'Optional, up to 5',
  dba_ai_gallery_publish_tags_max_tip: 'You can select at most 5 tags',
  dba_ai_gallery_publish_tags_required: 'Please select at least one tag',
  dba_ai_gallery_publish_tag_create_success: 'Tag created successfully',
  dba_ai_gallery_publish_tag_add: 'Add Tag',
  dba_ai_gallery_publish_tag_name_label: 'Tag name',
  dba_ai_gallery_publish_tag_name_cn_label: 'Chinese Tag',
  dba_ai_gallery_publish_tag_name_en_label: 'English Tag',
  dba_ai_gallery_publish_tag_new_placeholder: 'Tag name',
  dba_ai_gallery_publish_tag_cn_placeholder: 'Enter Chinese tag name',
  dba_ai_gallery_publish_tag_en_placeholder: 'Enter English tag name',
  dba_ai_gallery_publish_tag_max_length_tip:
    'Tag name must not exceed 20 characters',
  dba_ai_gallery_publish_tag_cn_max_length_tip:
    'Chinese tag name must not exceed 10 characters',
  dba_ai_gallery_publish_tag_en_max_length_tip:
    'English tag name must not exceed 20 characters',
  dba_ai_gallery_publish_tag_back: 'Back',
  // New API visibility fields
  dba_ai_gallery_publish_visibility: 'Access',
  dba_ai_gallery_publish_visibility_trigger_self:
    'Only me · Only you can access',
  dba_ai_gallery_publish_visibility_trigger_user:
    'Designated users · People you specify',
  dba_ai_gallery_publish_visibility_trigger_public:
    'Visible to all DataBrain · All DataBrain users',
  dba_ai_gallery_publish_visibility_self_title: 'Only me',
  dba_ai_gallery_publish_visibility_self_desc: 'Only you can access',
  dba_ai_gallery_publish_visibility_user_title: 'Designated users',
  dba_ai_gallery_publish_visibility_user_desc: 'Specify who can access',
  dba_ai_gallery_publish_visibility_public_title: 'Visible to all DataBrain',
  dba_ai_gallery_publish_visibility_public_badge: 'Also publish to gallery',
  dba_ai_gallery_publish_visibility_public_desc:
    'Visible to all members in Gallery',
  dba_ai_gallery_publish_data_mode: 'Data Type',
  dba_ai_gallery_publish_data_mode_required: 'Please select data type',
  dba_ai_gallery_publish_data_mode_demo: 'Demo Data',
  dba_ai_gallery_publish_data_mode_demo_desc:
    'Use sample data, ideal for quick preview',
  dba_ai_gallery_publish_data_mode_real: 'Real Data',
  dba_ai_gallery_publish_data_mode_real_desc:
    'Use real game data, visible only to authorized users',
  dba_ai_gallery_publish_user_search_placeholder: 'Search users to add',
  dba_ai_gallery_publish_share_users_hint:
    'Enter English name or email to search, e.g. zhangxiaoming',
  dba_ai_gallery_publish_share_users_required:
    'Add at least one user when access is "Designated users".',
  dba_ai_gallery_publish_email_placeholder:
    'Enter email; press Enter or comma to add',
  dba_ai_gallery_publish_email_invalid: 'Please enter a valid email',
  dba_ai_gallery_publish_designated_emails_required:
    'Add at least one email when access is "Designated users".',
  dba_ai_gallery_publish_designated_hint:
    'Press Enter or comma to confirm an email.',
  dba_ai_gallery_publish_error_required: 'Cannot be empty',
  dba_ai_gallery_publish_name_cn_required: 'Chinese Title cannot be empty',
  dba_ai_gallery_publish_name_en_required: 'English Title cannot be empty',
  dba_ai_gallery_publish_name_cn_max_length_tip:
    'Chinese Title must not exceed 40 characters',
  dba_ai_gallery_publish_name_en_max_length_tip:
    'English Title must not exceed 60 characters',
  dba_ai_gallery_publish_desc_cn_max_length_tip:
    'Chinese Description must not exceed 200 characters',
  dba_ai_gallery_publish_desc_en_max_length_tip:
    'English Description must not exceed 300 characters',
  dba_ai_gallery_publish_confirm: 'Publish',
  dba_ai_gallery_publish_submitting: 'Publishing...',
  dba_ai_gallery_publish_sensitive_tip:
    'The current content contains sensitive data. A publicly accessible webpage link will be generated after publishing. Please confirm whether to proceed.',
  dba_ai_gallery_publish_still_publish: 'Publish Anyway',
  dba_ai_gallery_publish_failed: 'Publish failed, please retry',
  dba_ai_gallery_publish_success: 'Published successfully',
  dba_ai_gallery_toolbar_copy: 'Copy',
  dba_ai_gallery_download_no_url: 'No downloadable URL yet.',
  dba_ai_gallery_copy_empty: 'Nothing to copy (no HTML source or preview URL).',
  dba_ai_gallery_copy_success: 'Copy success',
  dba_ai_gallery_copy_failed: 'Copy failed',
  /** Code tab: placeholder when no source */
  dba_ai_gallery_code_placeholder: 'No code content',
  dba_ds_model_btn_prephrase: 'Data Science Professional Report Generation',
  dba_back_to_copilot: 'Chat with Copilot',
  dba_copilot_mode_tip:
    'Copilot cannot be navigated in the current mode. Please switch to Smart QA mode.',
  dba_img_loading: 'Image loading...',
  dba_chart_draggable: 'Draggable',
  dba_chart_delete: 'Delete',
  dba_chart_delete_title: 'Delete Chart',
  dba_chart_delete_message:
    'The chart can be restored by resetting after deletion',
  dba_chart_delete_cancel: 'Cancel',
  dba_copilot_historical_conversations: 'Historical Conversations',
  dba_copilot_historical_conversations_no_data: 'No historical conversation',
  dba_copilot_chat_history: 'Chat History',
  dba_copilot_window_mode: 'Default Window',
  dba_copilot_floating_window: 'Floating window',
  dba_copilot_pin_tooltip_floating: 'Floating',
  dba_copilot_pin_tooltip_docked: 'Docked',
  dba_copilot_docked_window: 'Docked window',
  dba_copilot_docked_label: 'Docked',
  dba_copilot_docked_window_desc:
    'Copilot pins to the right side and the main content reflows. Best for long sessions.',
  dba_copilot_floating_window_desc:
    'When off, Copilot opens as a floating window',
  dba_copilot_floating_hover_desc:
    'When turned on, Copilot will be docked to the page by default.',
  dba_copilot_docked_hover_desc:
    'When turned off, Copilot will float on the page by default.',
  dba_use_template: 'From Template',
  dba_download_settings: 'Download Settings',
  dba_data_loading: 'Loading data...',
  dba_table_copy: 'Copy Table',
  dba_table_copy_success: 'Copied',
  dba_table_download: 'Download Table',
  dba_code_copy: 'Copy',
  dba_code_download: 'Download',
  dba_code_collapse: 'Collapse',
  dba_code_expand: 'Expand',
  dba_code_collapsed_lines: '{lines} lines collapsed',
  dba_use_case_title: 'Use Case',
  dba_use_case_view_chat: 'View Chat',

  // AgentCollection Page
  dba_collection_title: 'Agents',
  dba_collection_search_placeholder: 'Search Agents',
  dba_collection_empty: 'No results found',

  // AgentCard Component
  dba_collection_card_in_use: 'Currently in use',
  dba_collection_card_no_access: 'Unauthorized',
  dba_collection_card_try_now: 'Try Now',
  dba_collection_card_no_permission_text:
    'Unauthorized. Please contact Miamgao',

  // AgentSelector Component
  dba_collection_selector_recommended: 'Recommended',
  dba_collection_selector_default_name: 'DataBrain Agent',
  dba_collection_selector_header_title: 'Select Agent',
  // 思考模式
  dba_collection_selector_header_thinking: 'Thinking Mode',
  dba_collection_selector_header_more: 'More',
  dba_full_screen: 'Full Screen',

  // SkillsCollection page
  dba_skills_collection_title: 'Skills',
  // Skill detail page breadcrumb back button
  dba_skill_detail_back_title: 'Skill Details',
  dba_skills_collection_search_placeholder: 'Search Skills',
  dba_skills_collection_empty: 'No matching Skills found',
  dba_skills_upload_btn: 'Upload Skill',

  // Category TABs
  dba_skills_category_all: 'All',
  dba_skills_category_data_analysis: 'Data Analysis',
  dba_skills_category_opinion_analysis: 'Opinion Analysis',
  dba_skills_category_other: 'Other',

  // SkillCard component
  dba_skills_card_source_official: 'Official',
  dba_skills_card_source_personal: 'Personal',
  dba_skills_card_installed: 'Installed',
  dba_skills_card_not_installed: 'Not Installed',
  dba_skills_card_install: 'Install to DataBrain',
  dba_skills_card_install_tooltip: 'Install',
  dba_skills_card_download: 'Download',
  dba_skills_card_use: 'Use',
  dba_skills_card_chat_tooltip: 'Chat Now',
  dba_skills_card_token_tooltip: 'Get Token',
  dba_skills_card_detail_tooltip: 'View Details',
  dba_skills_mention_detail_tooltip: 'View Details',
  dba_skills_mention_detail_link: 'Details',

  // Skill detail page
  dba_skill_detail_tab_usage: 'Usage',
  dba_skill_detail_tab_linkage: 'Cases',
  dba_skill_detail_tab_version: 'Version History',
  dba_skill_detail_usage_count: 'Usage : ',
  dba_skill_detail_updated_at: 'Updated : ',
  dba_skill_detail_chat_now: 'Chat Now',
  dba_skill_detail_overview_title: 'Overview',
  dba_skill_detail_token_title: 'Token Setup',
  dba_skill_detail_token_tip_prefix:
    'If you need a token for first-time use, go to DataBrain User Center →',
  dba_skill_detail_token_link: 'Personal Token Center',
  dba_skill_detail_token_tip_suffix: 'to create and obtain a token.',
  dba_skill_detail_recommend_title: 'People who used this Skill also use',
  dba_skill_detail_linkage_try: 'Try in Brainy',
  dba_skill_detail_linkage_key_conclusions: 'Key Conclusions',
  dba_skill_detail_linkage_empty: 'No data',
  dba_skill_detail_version_empty:
    'You are already on the latest version. No update history available.',
  dba_skill_detail_version_current: 'Current',
  dba_skill_detail_version_col_version: 'Version',
  dba_skill_detail_version_col_info: 'Release Notes',
  dba_skill_detail_version_total: '{count} total items',
  dba_skill_detail_version_col_time: 'Update Time',
  // PosterStyleSelector Component
  dba_poster_style_label: 'Style:',
  dba_poster_style_custom: 'Custom',
  dba_poster_style_not_selected: 'Not selected',
  dba_poster_style_custom_placeholder:
    'Describe the visual style you want to generate',
  // Magic poster style reference text (displayed in Question component)
  dba_poster_style_ref: 'Generate magic poster with「{styleName}」style',

  // PosterPreviewPanel Component
  dba_poster_preview_loading: 'loading...',
  dba_poster_preview_not_generated: 'Poster not generated',
  dba_poster_preview_load_error: 'Content load failed, ',
  dba_poster_preview_retry: 'click to retry',

  // ReportStepTabs Component
  dba_report_step_disabled_tip: 'Plan and generate the report',
  // Smart Table Actions
  dba_smart_table_fill_column:
    'Add a new column to the table. Specify the column name [{columnName}] and describe how the data is derived, such as calculated from existing columns, a fixed value, or external input [{prompt}]',
  dba_smart_table_fill_row:
    'Add a new row to the table. Specify the corresponding condition for this row, such as date, region, or other dimension values [{prompt}]',
  dba_smart_table_modify_column_condition: '{prompt}',
  dba_smart_table_adjust_column_format: '{prompt}',

  // Smart Table - AIColumnPopover
  dba_smart_table_ai_column_modify_condition_template:
    'Modify the data filters or calculation conditions of column {colLetter} in the {sheetName} table. Specify the conditions to be adjusted, such as time range, region scope, or game category [fill in]',
  dba_smart_table_ai_column_adjust_format_template:
    'Adjust the data display format of column {colLetter} in the {sheetName} table. Specify the target format, such as units, percentage, decimal precision, or date format [fill in]',
  dba_smart_table_table: 'Table',

  // Smart Table - AIPolishPopover
  dba_smart_table_add_column: 'Add Column',
  dba_smart_table_add_row: 'Add Row',
  dba_smart_table_modify_data_condition: 'Modify Data Condition',
  dba_smart_table_adjust_data_format: 'Adjust Data Format',
  dba_smart_table_add_column_template:
    'Add a new column to the table. Specify the column name [fill in] and describe how the data is derived, such as calculated from existing columns, a fixed value, or external input [fill in]',
  dba_smart_table_add_row_template:
    'Add a new row to the table. Specify the corresponding condition for this row, such as date, region, or other dimension values [fill in]',
  dba_smart_table_modify_condition_template:
    'Modify the data filters or calculation conditions in the table. Specify the conditions to be adjusted, such as time range, region scope, or game category [fill in]',
  dba_smart_table_adjust_format_template:
    'Adjust the data display format in the table. Specify the columns to update [Fill in, e.g., Column A] and define the target format, such as units, percentage, decimal precision, or date format [fill in]',
  dba_smart_table_ai_help_title: 'Can help you, examples:',
  dba_smart_table_input_placeholder: 'Tell AI what you want to do',

  // Smart Table - AddRowColButton
  dba_smart_table_add_blank: 'Add Blank',
  dba_smart_table_smart_fill: 'Smart Fill',
  dba_smart_table_row: 'Row',
  dba_smart_table_column: 'Column',
  dba_smart_table_add_on_bottom: 'Add Row on bottom',
  dba_smart_table_add_on_right: 'Add Column on right',

  // Smart Table - ExcelSheetTabs
  dba_smart_table_create_copy: 'Create Copy',
  dba_smart_table_rename: 'Rename',
  dba_smart_table_delete: 'Delete',
  dba_smart_table_create_copy_success: 'Copy created successfully',
  dba_smart_table_name_exists: 'Name already exists, auto renamed to "{name}"',
  dba_smart_table_new_blank_sheet: 'New blank worksheet',
  dba_smart_table_confirm_delete_sheet:
    'Are you sure you want to delete this worksheet?',
  dba_smart_table_delete_sheet_title: 'Delete Worksheet',

  // Smart Table - SmartTableToolbar
  dba_smart_table_ai_polish: 'AI Polish Table',
  dba_smart_table_undo: 'Undo',
  dba_smart_table_redo: 'Redo',

  // Smart Table - TableActionsBar / constants
  dba_smart_table_reset: 'Reset',
  dba_smart_table_copy: 'Copy',
  dba_smart_table_export: 'Export',
  dba_smart_table_export_sensitive_disabled:
    'Download is not available by default for content containing sensitive data. To request access, please contact ivyyfchen.',
  dba_smart_table_save: 'Save',
  dba_smart_table_fullscreen: 'Full Screen',
  dba_smart_table_exit_fullscreen: 'Exit Full Screen',
  dba_smart_table_save_empty: 'Table data is empty, cannot save',
  dba_smart_table_save_success: 'Save succeeded',
  dba_smart_table_save_failed: 'Save failed',
  dba_smart_table_copy_success: 'Copy succeeded',

  // Smart Table - TableContextMenu
  dba_smart_table_ai_help: 'Can help you',
  dba_smart_table_modify_column_condition_label: 'Modify Column Data Condition',
  dba_smart_table_adjust_format_label: 'Adjust Data Format',
  dba_smart_table_sort_asc: 'Sort Ascending',
  dba_smart_table_sort_desc: 'Sort Descending',
  dba_smart_table_paste: 'Paste',
  dba_smart_table_insert_left: 'Insert Left',
  dba_smart_table_insert_right: 'Insert Right',
  dba_smart_table_clear_content: 'Clear Content',
  dba_smart_table_delete_column: 'Delete Column',
  dba_smart_table_insert_above: 'Insert Above',
  dba_smart_table_insert_below: 'Insert Below',
  dba_smart_table_delete_row: 'Delete Row',

  // Smart Table - SmartFillForm
  dba_smart_table_column_name: 'Column Name',
  dba_smart_table_column_name_placeholder: 'Fill in',
  dba_smart_table_column_name_required: 'Column name is required',
  dba_smart_table_prompt_required: 'Prompt is required',
  dba_smart_table_column_prompt_placeholder:
    'The calculation method or data source of this column - based on existing column calculation, fixed value or external supplement',
  dba_smart_table_row_prompt_placeholder:
    'The corresponding conditions of this row - such as date, region or other dimension values',

  // Smart Table - Others
  dba_smart_table_placeholder: 'Smart Table',
  dba_smart_table_editable_text: 'Fill in',
  dba_smart_table_sheet_name_empty: 'Worksheet name cannot be empty',
  dba_smart_table_sheet_name_quote_error:
    'Name cannot start or end with single quote',
  dba_smart_table_sheet_name_length_error:
    'Worksheet name cannot exceed 30 characters',
  dba_smart_table_sheet_name_char_error:
    'Name cannot contain the following characters: \\ / ? * [ ]',
  dba_smart_table_blank_sheet: 'Blank Worksheet',
  dba_smart_table_reset_title: 'Reset Content',
  dba_smart_table_reset_message:
    'This operation will restore the file to its original version. The operation cannot be undone. Do you want to continue?',
  dba_smart_table_reset_success: 'Successfully reset to the original version',
  dba_smart_table_confirm_delete_message: 'Are you sure you want to delete?',
  dba_smart_table_delete_success: 'Deleted successfully',

  // Smart Table - Export
  dba_smart_table_export_success: 'Export successful',
  dba_smart_table_export_failed: 'Export failed',
  dba_smart_table_export_no_data: 'No data to export',
  dba_smart_table_current_sheet: 'Current sheet',
  dba_smart_table_export_excel: 'Excel',
  dba_smart_table_export_csv: 'CSV(Current sheet)',
  dba_magic_poster_style_generated: ' style to generate magic poster, ',
  dba_magic_poster_data_placeholder:
    "Describe the data content required for the poster. You may outline the poster's data requirements (e.g., metrics, time range, or key findings).",

  // Opinion Report Card
  dba_opinion_report_card_link: 'Generate report task',

  // ChartPopover - 新建图表浮窗
  dba_new_chart_select_title: 'Type # or click to select pages or charts',
  dba_new_chart_select_title_tips:
    'Currently, only the DataLab report type (Dashboard system) is supported.',
  dba_new_chart_game_label: 'Game',
  dba_new_chart_game_placeholder: 'Select Game',
  dba_new_chart_second_level_title: 'Pages',
  dba_new_chart_chart_title: 'Charts',
  dba_new_chart_game_group_recent: 'Recent Viewed',
  dba_new_chart_game_group_others: 'Others',
  dba_chart_ref_tooltip_title: 'Referenced Data',
  dba_copilot_input_chart_hover_tip: 'Click to select pages or charts',
  dba_copilot_input_thinking_hover_tip: 'Click to select a thinking mode',
  dba_gallery_default_text:
    'Retrieve the DAU trends for Arrows Puzzle Escape from the past month and generate a clean, visually appealing HTML dashboard',

  // Memory feature related text
  dba_memory_management: 'Memory',
  dba_memory_title: 'Memory Management',
  dba_enable_memory: 'Enable Memory',
  dba_memory_enabled_desc:
    'Brainy will automatically use saved analysis preferences, report formats, and recent topics in subsequent analyses for a more continuous and personalized experience.',
  dba_memory_disabled_desc:
    'Existing memories will be retained for viewing only. They will not be used for generating responses, nor will new or updated memories be created. Re-enable to continue using them.',
  dba_memory_summary: 'Memory Summary',
  dba_no_memory: 'No memories yet',
  dba_ds_template_select_title: 'Please Select Analysis Template',

  // MorePlatformBtn
  dba_platform_more_btn: 'Use on More Platforms',
  dba_platform_pre_in: 'In ',
  dba_platform_workbuddy_desc1:
    'WorkBuddy, click「Expert · Skills · Connectors」in the top-left corner, search',
  dba_platform_workbuddy_desc2:
    'for「DataBrain」, and you can use DataBrain Data Expert 2.0 and more.',
  dba_platform_wecom_desc: 'Enterprise WeChat, ',
  dba_platform_open: 'Open ',
  dba_platform_wecom_name: 'Enterprise WeChat',
  dba_platform_chat: 'Chat',
  dba_platform_knot_desc1: 'the Knot Skills Market and search「',
  dba_platform_knot_desc2: '」to unlock multiple official Skills.',
};
